<div
    class="border-0 smallwidth cmps-widget-coaching-insight"
    *ngIf="!_hideWidget"
>
    <div
        class="card border-0"
        role="complementary"
        [attr.aria-labelledby]="compConfig?.id"
    >
        <div class="card-body">
            <div class="container-fluid mb-0">
                <div class="coaching-performer-container cmps-cdk-min-h-70p">
                    <div
                        class="performer-stats-area cmps-widget-coaching-insight--user-header cmps-cdk-px-0dot75 cmps-cdk-overflow-hidden"
                    >
                        <cmps-ciw-user
                            class="cmps-cdk-d-block cmps-cdk-h-100p cmps-cdk-w-100pct"
                            [imageUrl]="_userImage"
                            (select)="_onUserChange($event)"
                            (search)="onSelectUserClick($event)"
                        >
                            <div class="cmps-ciw-user--name">
                                {{
                                    state?.user?.firstName?.trim() +
                                        ' ' +
                                        state?.user?.lastName?.trim()
                                }}
                            </div>
                            <div class="cmps-ciw-user--labels">
                                <div
                                    cmpsUserInfoLabel
                                    *ngIf="state?.user?.superGroup"
                                >
                                    {{ _i18n._9552_SG_ | translate }}
                                    {{ state?.user?.superGroup }}
                                </div>

                                <div
                                    class="cmps-widget-coaching-insight--user-info-viewing"
                                    cmpsUserInfoLabel
                                    *ngIf="_oaUser"
                                >
                                    {{ _i18n._9677_VIEWING_ | translate }}
                                    {{ _oaUser?.firstName }}
                                    {{ _oaUser?.lastName }}
                                </div>
                            </div>
                            <div class="cmps-ciw-user--badges">
                                <ng-container
                                    *ngIf="
                                        state?.selectedKpi?.kpiTypeId ===
                                            _KpiType.COACHING_COVERAGE ||
                                        state?.selectedKpi?.kpiTypeId ===
                                            _KpiType.OPPORTUNITY_ALIGNMENT ||
                                        state?.selectedKpi?.kpiTypeId ===
                                            _KpiType.FRONT_LINE_OA
                                    "
                                >
                                    <cmps-user-info-badge
                                        [label]="_i18n._9676_OA_ | translate"
                                        [value]="
                                            (_oaUser || state?.oaUser)
                                                ?.oaScore == null
                                                ? '-'
                                                : ((_oaUser || state?.oaUser)
                                                      ?.oaScore / 100
                                                  | cmpsPercent: '1.0-2')
                                        "
                                        [backgroundColor]="
                                            (_oaUser || state?.oaUser)
                                                ?.oaThresholdColour || '#000'
                                        "
                                        [textColor]="'#fff'"
                                        *ngIf="_oaUser || state?.oaUser"
                                    ></cmps-user-info-badge>
                                </ng-container>
                            </div>
                        </cmps-ciw-user>
                    </div>
                    <div class="kpi-nav-area">
                        <div
                            cmpsCoachingNavigationBar
                            [kpis]="state?.kpis"
                            [selectedPeriodType]="state?.selectedPeriodType"
                            [selectedKpi]="state?.selectedKpi"
                            (selectionChange)="_onKpiChange($event)"
                            *ngIf="state?.kpis != null"
                        ></div>
                    </div>
                </div>

                <!--think of it as if human-insight was inside performance-insight-->
                <ng-container [ngSwitch]="state?.selectedKpi?.kpiTypeId">
                    <div
                        *ngSwitchCase="_KpiType.COACHING_COVERAGE"
                        cmpsCoachingCoverage
                        [context]="state?.coverageContext"
                    ></div>
                    <ng-container
                        *ngSwitchCase="_KpiType.OPPORTUNITY_ALIGNMENT"
                    >
                        <ng-container *ngTemplateOutlet="oaTpl"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="_KpiType.FRONT_LINE_OA">
                        <ng-container *ngTemplateOutlet="oaTpl"></ng-container>
                    </ng-container>
                    <cmps-mi2-main
                        *ngSwitchCase="_KpiType.MANAGEMENT_IMPROVEMENT_INDEX"
                        [userId]="state?.user?.id"
                    ></cmps-mi2-main>
                    <cmps-coaching-wp-main
                        *ngSwitchCase="_KpiType.WINNING_PERCENTAGE"
                        [userId]="state?.user?.id"
                    ></cmps-coaching-wp-main>
                    <cmps-mi2-grid-main
                        *ngSwitchCase="_KpiType.FL_MANAGEMENT_IMPROVEMENT_INDEX"
                        (flmi2PersonChange)="_onMI2UserChange($event)"
                        [selecteduser]="state?.user?.id"
                    ></cmps-mi2-grid-main>
                    <cmps-coaching-wp-main
                        *ngSwitchCase="_KpiType.FL_WINNING_PERCENTAGE"
                        [userId]="state?.user?.id"
                    ></cmps-coaching-wp-main>
                    <div *ngSwitchDefault>
                        <div class="text-center">
                            {{ state?.selectedKpi?.kpiName }}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #oaTpl>
    <cmps-widget-oa-sm
        [selectedFavouriteView]="{ userId: state?.user?.id }"
        (floaPersonChange)="_onOaUserChange($event)"
        [coachingInsightUserId]="state?.user?.id"
        [preferCoachingComponentTypeOA]="
            state?.selectedKpi?.kpiTypeId === _KpiType.OPPORTUNITY_ALIGNMENT
        "
        [periodTypeId]="state?.selectedPeriodType?.periodTypeId"
        [periodTypeDate]="state?.selectedPeriodType?.periodTypeDate"
    >
    </cmps-widget-oa-sm>
</ng-template>
